import { render, staticRenderFns } from "./ITNotAssetAllocation.vue?vue&type=template&id=81245f20&scoped=true"
import script from "./ITNotAssetAllocation.vue?vue&type=script&lang=js"
export * from "./ITNotAssetAllocation.vue?vue&type=script&lang=js"
import style0 from "./ITNotAssetAllocation.vue?vue&type=style&index=0&id=81245f20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81245f20",
  null
  
)

export default component.exports